export const GET_HADER_LOGS_REQUEST = 'GET_HADER_LOGS_REQUEST';
export const GET_HADER_LOGS_SUCCESS = 'GET_HADER_LOGS_SUCCESS';
export const GET_HADER_LOGS_FAIL = 'GET_HADER_LOGS_FAIL';

export const HADER_DAY_UPDATE_REQUEST = 'HADER_DAY_UPDATE_REQUEST';
export const HADER_DAY_UPDATE_SUCCESS = 'HADER_DAY_UPDATE_SUCCESS';
export const HADER_DAY_UPDATE_FAIL = 'HADER_DAY_UPDATE_FAIL';

export const GET_HADER_DAY_LOGS_REQUEST = 'GET_HADER_DAY_LOGS_REQUEST';
export const GET_HADER_DAY_LOGS_SUCCESS = 'GET_HADER_DAY_LOGS_SUCCESS';
export const GET_HADER_DAY_LOGS_FAIL = 'GET_HADER_DAY_LOGS_FAIL';

export const GET_HADER_TODAY_LOGS_REQUEST = 'GET_HADER_TODAY_LOGS_REQUEST';
export const GET_HADER_TODAY_LOGS_SUCCESS = 'GET_HADER_TODAY_LOGS_SUCCESS';
export const GET_HADER_TODAY_LOGS_FAIL = 'GET_HADER_TODAY_LOGS_FAIL';

export const HADER_DAY_SET_REQUEST = 'HADER_DAY_SET_REQUEST';
export const HADER_DAY_SET_SUCCESS = 'HADER_DAY_SET_SUCCESS';
export const HADER_DAY_SET_FAIL = 'HADER_DAY_SET_FAIL';
